import api from "../../../services/api";

export const fetchInventory = async (params) => {
  let query = '';
  if (typeof params === 'string') {
    query = `?serviceType=${params}`;
  } else if (typeof params === 'object' && params !== null) {
    const searchParams = new URLSearchParams(params);
    query = `?${searchParams.toString()}`;
  }
  return await api.get(`/inventory${query}`);
};

export const updateInventoryItem = async (id, data) => {
  return await api.patch(`/inventory/${id}`, data);
};

export const addItem = async (data) => {
  return await api.post('/inventory', data);
};

export const createPurchase = async (data) => {
  return await api.post('/inventory/purchases', data);
};

export const fetchPurchases = async (serviceType) => {
  const query = serviceType ? `?serviceType=${serviceType}` : '';
  return await api.get(`/v1/purchase-master${query}`);
};

export const fetchPurchaseTransactions = async (serviceType) => {
  const query = serviceType ? `?serviceType=${serviceType}` : '';
  return await api.get(`/inventory/purchases${query}`);
};

export const fetchOpeningStocks = async (serviceType) => {
  const query = serviceType ? `?serviceType=${serviceType}` : ''; 
  return await api.get(`/inventory/opening-stock${query}`);
};

export const createOpeningStock = async (data) => {
  return await api.post('/inventory/opening-stock', data);
};

export const updateOpeningStock = async (id, data) => {
  return await api.put(`/inventory/opening-stock/${id}`, data);
};

export const deleteOpeningStock = async (id) => {
  return await api.delete(`/inventory/opening-stock/${id}`);
};

export const fetchPurchaseByInvoice = async (invoiceNo) => {
  try {
    return await api.get(`/inventory/purchase-returns/by-invoice/${invoiceNo}`);
  } catch (err) {
    if (err.response && err.response.status === 404) {
      return await api.get(`/inventory/blum-purchases/by-invoice/${invoiceNo}`);
    }
    throw err;
  }
};

export const updatePurchase = async (id, data, isFallback) => {
  if (isFallback) {
    return await api.patch(`/inventory/blum-purchases/${id}`, data);
  }
  return await api.patch(`/inventory/purchases/${id}`, data);
};

export const createMaterialReturn = async (data) => {
  return await api.post('/inventory/material-returns', data);
};

export const deleteItem = async (id) => {
  return await api.delete(`/inventory/${id}`);
};

export const fetchMaterialRequests = async (serviceType) => {
  const query = serviceType ? `?serviceType=${serviceType}&limit=10000` : '?limit=10000';
  return await api.get(`/inventory/material-requests${query}`);
};

export const updateRequestStatus = async (id, status) => {
  return await api.put(`/inventory/material-requests/${id}/status`, { status });
};

export const ownerApproveRequest = async (id) => {
  return await api.put(`/material-requests/${id}/owner-approve`);
};

export const fetchMaterialReturns = async (serviceType) => {
  const query = serviceType ? `?serviceType=${serviceType}&limit=10000` : '?limit=10000';
  return await api.get(`/inventory/material-returns${query}`);
};

export const fetchSales = async (serviceType) => {
  const query = serviceType ? `?serviceType=${serviceType}&limit=10000` : '?limit=10000';
  return await api.get(`/inventory/sales${query}`);
};

export const fetchNextInvoiceNo = async () => {
  return await api.get('/inventory/sales/next-invoice-no');
};

export const createSale = async (data) => {
  return await api.post('/inventory/sales', data);
};

export const fetchPurchaseReturns = async (serviceType) => {
  const query = serviceType ? `?serviceType=${serviceType}&limit=10000` : '?limit=10000';
  return await api.get(`/inventory/purchase-returns${query}`);
};

export const fetchSaleReturns = async (serviceType) => {
  const query = serviceType ? `?serviceType=${serviceType}&limit=10000` : '?limit=10000';
  return await api.get(`/inventory/sale-returns${query}`);
};

export const createPurchaseReturn = async (data) => {
  return await api.post('/inventory/purchase-returns', data);
};

export const getEmptyItem = (serviceType) => ({
  name: "",
  category: "Kitchen Cabinets",
  unit: "piece",
  availableQty: 0,
  minQty: 0,
  unitPrice: 0,
  supplier: "",
  sku: "",
  itemCode: "",

  serviceType: serviceType || "verve",

  // New Purchase Entry fields
  type: "Stockable",
  brand: "",
  hsnCode: "",
  isUnique: false,
  uniqueName: "",
  hasBatchExpiry: false,
  expiryDate: "",
  barcode: "",
  description: "",
  invoiceNo: "",
  invoiceDate: new Date().toISOString().split('T')[0],
  businessUnit: "VERVE KITCHENS",
  store: "",
  rate: 0,
  quantity: 1,
  bvPoints: 0,
  taxP: 0,
  baseAmount: 0,
  discP: 0,
  discount: 0,
  taxable: 0,
  igst: 0,
  cgst: 0,
  sgst: 0,
  taxAmount: 0,
  netBill: 0,
  chargeAmount: 0,
  adjustments: 0,
  netPayment: 0,
  items: []
});

export const CATEGORIES = {
  verve: ["Kitchen Cabinets", "Shutters", "Hardware & Fittings", "Carcase", "Appliances", "Accessories", "Countertops"]
};

export const UNITS = ["piece", "set", "ton", "meter", "kit", "box", "roll", "litre", "kg"];

export const inventoryService = {
  getInventory: fetchInventory,
  fetchInventory,
  updateInventoryItem,
  addItem,
  createPurchase,
  fetchPurchases,
  fetchPurchaseTransactions,
  fetchOpeningStocks,
  createOpeningStock,
  updateOpeningStock,
  deleteOpeningStock,
  fetchPurchaseByInvoice,
  updatePurchase,
  createMaterialReturn,
  deleteItem,
  fetchMaterialRequests,
  updateRequestStatus,
  ownerApproveRequest,
  fetchMaterialReturns,
  fetchSales,
  fetchNextInvoiceNo,
  fetchPurchaseReturns,
  fetchSaleReturns,
  createPurchaseReturn
};
